<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        :items="sortedWarnings"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="false"
                        headlineKey="name"
                        v-model="selectedWarningID"
                        filterLabel="Filter Warnings"
                >
                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createWarningShow = !createWarningShow"
                        >
                            <v-icon left>mdi-plus</v-icon>
                            Add Warning
                        </v-btn>
                    </div>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedWarning" style="min-width: 700px">
                <v-card>
                    <ModifyWarning :edit-warning="selectedWarning" @save="upsertWarning($event)"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createWarningShow && createWarningObj"
                    v-model="createWarningShow"
                    :width="700"
                    persistent
            >
                <v-card>
                    <ModifyWarning :edit-warning="createWarningObj" @dismiss="createWarningShow = !createWarningShow" @save="upsertWarning($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyWarning from "./ModifyWarning";
import {waitForEvent} from "@/core/socket";
import Divider from "../../General/Divider";
import {Warning} from "@/core/store";

export default {
    components: {Divider, ModifyWarning, MultiSelectList},
    props: {},
    data() {
        return {
            selectedWarningID: null,
            createWarningObj: null,
            createWarningShow: false,
        }
    },
    watch: {
        createWarningShow(val) {
            if (val)
                this.createWarningObj = new Warning()
        }
    },
    methods: {
        async upsertWarning(event) {

            console.log({event})

            let {warning, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/warning`, warning)
                const addedWarningID = (await waitForEvent(eventID)).warnings.pop().id
                this.createWarningShow = false
                this.selectedWarningID = addedWarningID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }

    },
    computed: {
        ...mapGetters(['warnings', 'warningsRef']),
        sortedWarnings() {
            return [...this.warnings].sort((a,b) => a.name > b.name ? 1 : -1)
        },
        selectedWarning() {
            if (!this.selectedWarningID)
                return null
            console.log(this.warnings, this.selectedWarningID, this.warnings.find(obj => obj.id === this.selectedWarningID))
            return this.warnings.find(obj => obj.id === this.selectedWarningID)
        }
    },
}
</script>

<style scoped>

</style>